import * as B from '@blueprintjs/core';
import {ErrorBoundary} from '@sentry/react';
import classnames from 'classnames';
import React from 'react';

import * as cs from './Dashboard.styl';

/**
 * A generic widget for the dashboard. Controls size and layout
 * of content on the dashboard.
 */
export const DashboardWidget: React.FC<{
  title: string | React.ReactNode;
  //   description: string; // TODO - add description
  size: 'small' | 'large';
  children: React.ReactNode;
  controls?: React.ReactNode;
}> = ({title, size, children, controls}) => {
  return (
    <div
      className={classnames(
        cs.dashboardWidget,
        size === 'large' ? cs.dashboardWidgetLarge : cs.dashboardWidgetSmall
      )}
    >
      <div className={cs.dashboardWidgetHeader}>
        <h3>{title}</h3>
        {/* ErrorBoundary for controls - if this gets triggered, 
        we will send an error to Sentry. But not the user. */}
        <ErrorBoundary>{controls}</ErrorBoundary>
      </div>
      {/* ErrorBoundary for children -  show nonIdealState to user */}
      <ErrorBoundary
        fallback={
          <B.NonIdealState
            icon="error"
            iconMuted={false}
            title="Error"
            description={'Error visualizing data.'}
          />
        }
      >
        {children}
      </ErrorBoundary>
    </div>
  );
};
